"use strict";

import React, {Component} from "react";
import PropTypes from "prop-types";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class ExpandableBox extends Component {

    static defaultProps = {

    };

    static propTypes = {
        icon: PropTypes.string ,
        header: PropTypes.string,
        content: PropTypes.oneOfType([
                     PropTypes.arrayOf(PropTypes.node),
                     PropTypes.node
                 ]),
    };

    constructor(props) {
        super(props);
        this.state = {
            collapsed : true,
        }

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({ collapsed : !this.state.collapsed })
    }

    render() {
        const { icon, header, content } = this.props;
        const { collapsed } = this.state;

        const style = {}
        const show = collapsed ? "collapsed" : ""

        return (
            <div className="box box-default">
                {this.renderBoxHeader(icon, header, collapsed)}
                <div className={ "box-body-wrapper " + show }>
                    {this.renderBoxContent(content, collapsed)}
                </div>
            </div>
        );
    }

    renderBoxHeader(icon, header, collapsed) {
        const toggleIcon = collapsed ? "plus" : "minus";
        return header || icon
               ? <div className="box-header with-border">
                     <i className="fa">{icon ? <FontAwesomeIcon icon={icon} /> : null}</i>
                     {header ? <h3 className="box-title">{header}</h3> : null}
                     <div className="box-tools pull-right">
                         <button type="button" className="btn btn-box-tool" onClick={ this.toggle }>
                             <i className="fa"><FontAwesomeIcon icon={ toggleIcon } /></i>
                         </button>
                     </div>
                 </div>
               : null;
    }

    renderBoxContent(content, collapsed) {
        return content
               ? <div className="box-body">
                     {content}
                 </div>
               : null;
    }
}

export default ExpandableBox;
